// @flow
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./most-adjunct.production.js');
} else {
  module.exports = require('./most-adjunct.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/most-adjunct/dist/es/most-adjunct.js
// module id = 95
// module chunks = 0